var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{key:_vm.currentPageID,staticClass:"single page main margin-bottom-lg"},[(!_vm.isProtected)?_c('SingleHeading'):_vm._e(),(!_vm.isProtected)?_c('ModuleBuilder'):_c('PasswordProtection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }